export default __webpack_public_path__ + "static/media/icon_chevron_down.091792b5.svg";